import React, { useState, useEffect } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { sendError } from '../../../appsignal';
import fetchBestofConfig from '../../../utils/fetchBestofConfig';
import EventBar from './EventBar';
import BestOf from './BestOf';

////////////////////////////////////////////
// TODO MISSING TESTS: fetch best of in useEffect
////////////////////////////////////////////

const EventCommonPart = ({
  event,
  expandBestOfOnInit,
  liftUpBestofPosition,
  onExtrasClick,
  children,
  sendBestOfAvailability,
}) => {
  const params = useParams();
  const [bestOfAvailable, setBestOfAvailable] = useState(false);
  const [shouldExpandBestOf, setShouldExpandBestOf] = useState(
    params.bestof ? true : false
  );

  useEffect(() => {
    fetchBestofConfig(event.sgId, 'HEAD')
      .then((config) => {
        setBestOfAvailable(config.isAvailable);
        sendBestOfAvailability && sendBestOfAvailability(config.isAvailable);
      })
      .catch((error) => {
        sendError(error);
      });
  }, []);

  const handleExpandBestof = () => {
    setShouldExpandBestOf(true);
  };

  return (
    <>
      <EventBar
        event={event}
        onExpandBestof={handleExpandBestof}
        bestOfAvailable={bestOfAvailable}
        onExtrasClick={onExtrasClick}
      />
      {children}
      {bestOfAvailable && (
        <BestOf
          sgId={event.sgId}
          expanded={expandBestOfOnInit}
          liftUpBestofPosition={liftUpBestofPosition}
          shouldExpandBestOf={shouldExpandBestOf}
        />
      )}
    </>
  );
};

EventCommonPart.propTypes = {
  event: PropTypes.object,
  expandBestOfOnInit: PropTypes.bool,
  liftUpBestofPosition: PropTypes.func,
  onExtrasClick: PropTypes.func,
  children: PropTypes.node,
  sendBestOfAvailability: PropTypes.func,
};

export { EventCommonPart };

export default createFragmentContainer(EventCommonPart, {
  event: graphql`
    fragment EventCommonPart_event on Event {
      sgId
      ...EventBar_event
    }
  `,
});
